const compareWithHomeToGoState = ref<boolean>(false)

export function hometogoCheckboxState() {
  function updateState(value: boolean) {
    compareWithHomeToGoState.value = value
  }

  function getState(): boolean {
    return compareWithHomeToGoState.value
  }

  return {
    compareWithHomeToGoState,
    updateState,
    getState,
  }
}
